export default "__VITE_ASSET__hMYWG7bw__"